import { useEffect } from 'react';

import { IProps } from './types';

/** При дизейбле одного из свойств можно очистить значение, если это свойство было выбрано раньше **/
export const useCleanDisabledSelector = ({ source, value, onChange }: IProps) => {
  useEffect(() => {
    if (!source) {
      return;
    }

    for (const element of source) {
      if (element.value === value && element.disabled) {
        onChange();
      }
    }
  }, [value, source, onChange]);
};
